import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { About } from "@/components/About";
import { WhyUs } from "@/components/WhyUs";
import { Services } from "@/components/Services";
import { SnowRemoval } from "@/components/SnowRemoval";
import { Gallery } from "@/components/Gallery";
import { Story } from "@/components/Story";
import { Videos } from "@/components/Videos";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingCall } from "@/components/FloatingCall";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <About />
        <WhyUs />
        <Services />
        <SnowRemoval />
        <Gallery />
        <Story />
        <Videos />
        <Contact />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}

export default App;
